import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import DateInput from '../common/DateInput';
import { exportApi } from '../../api/services';
import { useAlerts } from '../../custom/Alerts';
import { addDays, monthRangeLabel, startOfToday } from '../../utils/dates';
import { blobError, download, useReportCompanies, useReportStatus } from './reportUtils';
import { ReportFooter, ReportProgress } from './ReportForm';

/* Psihofizičko stanje: mesečna evidencija (X = dan sa aktivnošću) za sve vozače kompanije. */
export default function PsychophysicalForm({ onClose }) {
    const alerts = useAlerts();
    const { companies, company, setCompany } = useReportCompanies(true); // uključuje "Bez kompanije"
    const status = useReportStatus();
    const [from, setFrom] = useState(startOfToday());
    const [to, setTo] = useState(addDays(startOfToday(), 7));

    const generate = async () => {
        status.start();
        try {
            const res = await exportApi.psychostate({ companyId: company ? company.id : null, startDate: from, endDate: to });
            download(res, `Psihofizicko stanje - ${company ? company.name : 'Bez Kompanije'} - ${monthRangeLabel(from, to)}.xlsx`);
            status.done();
        } catch (e) {
            status.fail();
            alerts.error(await blobError(e));
        }
    };

    return (
        <Dialog visible header="Psihofizičko stanje" onHide={onClose} style={{ width: '40rem', maxWidth: '96vw' }} modal
            footer={<ReportFooter onClose={onClose} onGenerate={generate} disabled={!from || !to || status.state.busy} busy={status.state.busy} />}>
            <div className="form-grid cols-2">
                <div className="field span-all"><label htmlFor="ps-company">Kompanija</label>
                    <Dropdown inputId="ps-company" value={company} options={companies} optionLabel="name" dataKey="id" filter onChange={(e) => setCompany(e.value)} /></div>
                <div className="field"><label htmlFor="ps-from">Od</label>
                    <DateInput inputId="ps-from" value={from} onChange={(e) => setFrom(e.value)} dateFormat="dd.mm.yy" showIcon /></div>
                <div className="field"><label htmlFor="ps-to">Do</label>
                    <DateInput inputId="ps-to" value={to} onChange={(e) => setTo(e.value)} dateFormat="dd.mm.yy" showIcon /></div>
            </div>
            <ReportProgress status={status.state} />
        </Dialog>
    );
}
